module.exports = __webpack_public_path__ + "img/102-balearic-islands.4cbac453.svg";